/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
});

export namespace Wrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const Wrapper: React.SFC<Wrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.wrapper)} {...htmlProps}>
      {children}
    </div>
  );
};
